module.exports = __webpack_public_path__ + "static/media/f360.10272045.svg";